// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","4814":"70cfe1b1"}[chunkId] || chunkId) + "." + {"296":"00978775b91b8ac2","4032":"cbfdeac85e831ca6","4814":"89fe6af90b122c8a","7229":"d6d011e91f49b286","9464":"ffe865e077b23ded"}[chunkId] + ".js";
};